export type ConsumerView = "chat" | "sessions" | "channels" | "integrations" | "usage" | "automations" | "skills" | "devices" | "settings" | "download";

export type NavTab = {
  id: ConsumerView;
  label: string;
  icon: string;
  /** If true, show only in the sidebar (not in the mobile tab bar) */
  sidebarOnly?: boolean;
};

const a = `viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"`;

export const TABS: NavTab[] = [
  {
    id: "chat",
    label: "Chat",
    icon: `<svg ${a}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
  },
  {
    id: "sessions",
    label: "Sessions",
    icon: `<svg ${a}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="9" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="13" y2="14"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "channels",
    label: "Channels",
    icon: `<svg ${a}><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>`,
  },
  {
    id: "integrations",
    label: "Integrations",
    icon: `<svg ${a}><path d="M4 11a5 5 0 0 1 5-5h2"/><path d="M20 13a5 5 0 0 1-5 5h-2"/><line x1="13" y1="6" x2="9" y2="6"/><line x1="11" y1="18" x2="15" y2="18"/><circle cx="7" cy="6" r="2"/><circle cx="17" cy="18" r="2"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "usage",
    label: "Usage",
    icon: `<svg ${a}><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "automations",
    label: "Automations",
    icon: `<svg ${a}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "skills",
    label: "Skills",
    icon: `<svg ${a}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "devices",
    label: "Devices",
    icon: `<svg ${a}><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
    sidebarOnly: true,
  },
  {
    id: "settings",
    label: "Settings",
    icon: `<svg ${a}><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>`,
  },
];

/** Tabs that only appear in the sidebar (accessible via "More" on mobile) */
export const SIDEBAR_ONLY_TABS: NavTab[] = TABS.filter((t) => t.sidebarOnly);

const a2 = `viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"`;

/** Tabs shown in the mobile bottom tab bar (4 items including "More") */
export const MOBILE_TABS: Array<NavTab | { id: "more"; label: string; icon: string }> = [
  TABS.find((t) => t.id === "chat")!,
  TABS.find((t) => t.id === "channels")!,
  TABS.find((t) => t.id === "settings")!,
  {
    id: "more",
    label: "More",
    icon: `<svg ${a2}><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></svg>`,
  },
];

const VALID_VIEWS = new Set<string>(TABS.map((t) => t.id));

export function getViewFromHash(): ConsumerView {
  const hash = window.location.hash.replace("#", "");
  if (hash === "download") return "download";
  if (VALID_VIEWS.has(hash)) return hash as ConsumerView;
  return "chat";
}

export function setViewHash(view: ConsumerView): void {
  window.location.hash = view === "chat" ? "" : view;
}
